// Venturist — the Superluxury private club experience

const pano = (id: string) => `https://dl.polyhaven.org/file/ph-assets/HDRIs/extra/Tonemapped%20JPG/${id}.jpg`;

// The 3D threshold that opens the Venturist page
export const ventureGate = {
  kicker: 'Superluxury presents',
  enterLabel: 'Enter Venturist',
  hint: 'Hover to enter · drag to look around',
  // 360° hall behind the gate
  gateImage: pano('dikhololo_night'),
  gateFallback: 'https://cdn.magicpatterns.com/patterns/generated-images/2b8dc8c3-7714-476c-b346-538b1ce3a50d.jpg',
};

export type VentureSpaceScene = {
  chapter: string;
  time: string;
  place: string;
  title: string;
  line: string;
  chips: string[];
  image: string; // 360° equirectangular environment
  fallback: string; // shown if the 360° view cannot load
  details?: { label: string; value: string }[];
  face?: 'light'; // open the view facing the brightest part of the sky (e.g. the sunset)
  wide?: boolean; // a cinematic wide panorama (not full 360°); looking around is limited to its edges
};

// The 360° environments walked through after entering — one day and one night of the club, in order
export const ventureSpaceScenes: VentureSpaceScene[] = [
  {
    chapter: 'First Light',
    time: '06:20',
    place: 'A private shore, Indian Ocean',
    title: 'The beach is closed. To everyone else.',
    line: 'Sunrise, the sea and a breakfast set for one table.',
    chips: ['Shore held until 10:00', 'No signal'],
    image: pano('umhlanga_sunrise'),
    fallback: 'https://cdn.magicpatterns.com/patterns/generated-images/efcc7901-ba53-456d-920b-d2389b4b0c8a.jpg',
  },
  {
    chapter: 'La Playa',
    time: '11:30',
    place: 'A Mediterranean playa',
    title: 'Pale sand, clear water, and no one else.',
    line: 'Loungers set beneath the pines, the morning swim already waiting.',
    chips: ['Beach held until 15:00', 'Tender offshore'],
    image: pano('spiaggia_di_mondello'),
    fallback: 'https://cdn.magicpatterns.com/patterns/generated-images/efcc7901-ba53-456d-920b-d2389b4b0c8a.jpg',
  },
  {
    chapter: 'The Sundowner',
    time: '17:50',
    place: 'The seafront, as the sky catches fire',
    title: 'The sky ignites. The glasses are already poured.',
    line: 'Waves turning copper, the yacht waiting just offshore.',
    chips: ['Champagne on ice', 'Tender at 18:30'],
    image: pano('the_sky_is_on_fire'),
    face: 'light',
    fallback: 'https://cdn.magicpatterns.com/patterns/generated-images/493d92cf-e2a4-4923-bd5d-29c66cf52b74.jpg',
  },
  {
    chapter: 'By Water',
    time: '18:40',
    place: 'The lagoon, Venice',
    title: 'The tender waits at a jetty with no name.',
    line: 'Out past the last vaporetto, as the city turns gold.',
    chips: ['Yacht at anchor', 'Jetty held'],
    image: pano('venice_sunset'),
    face: 'light',
    fallback: 'https://cdn.magicpatterns.com/patterns/generated-images/493d92cf-e2a4-4923-bd5d-29c66cf52b74.jpg',
  },
  {
    chapter: 'The Private Dinner',
    time: '21:00',
    place: 'An old square, Liguria',
    title: 'The square is quiet. The table is set.',
    line: 'Lamplight on wet stone, a chef cooking for twelve.',
    chips: ['Under NDA', 'Table for twelve'],
    image: pano('vignaioli_night'),
    fallback: 'https://cdn.magicpatterns.com/patterns/generated-images/3b1ad854-5cec-469e-b2b8-2295b9a690db.jpg',
  },
  {
    chapter: 'The Seafront',
    time: '23:10',
    place: 'The waterfront, at blue hour',
    title: 'The waterfront, lit for a few hundred guests.',
    line: 'Golden lamps on still water, the night just beginning.',
    chips: ['By invitation', 'No photographs'],
    image: pano('golden_bay'),
    face: 'light',
    fallback: 'https://cdn.magicpatterns.com/patterns/generated-images/b57c48d5-5d6c-4349-8ce0-a637e308681d.jpg',
    details: [
      { label: 'Where', value: 'Announced to members' },
      { label: 'When', value: 'Four seasons a year' },
      { label: 'Guests', value: 'By invitation' },
    ],
  },
];

export const velarisClosing = {
  line: 'Venturist — never announced, never repeated, never forgotten.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/493d92cf-e2a4-4923-bd5d-29c66cf52b74.jpg',
  alt: 'Guests in evening wear on the deck of a superyacht at night',
  details: [
    { label: 'Where', value: 'Announced to members' },
    { label: 'When', value: 'Four seasons a year' },
    { label: 'Guests', value: 'By invitation' },
  ],
};
